import { render, staticRenderFns } from "./selectProducts.vue?vue&type=template&id=3c4f86dc&scoped=true&"
import script from "./selectProducts.vue?vue&type=script&lang=js&"
export * from "./selectProducts.vue?vue&type=script&lang=js&"
import style0 from "./selectProducts.vue?vue&type=style&index=0&id=3c4f86dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f86dc",
  null
  
)

export default component.exports